import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  GoogleLogin,
  type CredentialResponse,
} from "@react-oauth/google";


function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await fetch("/users/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          password
        })
      });

      const data = await res.json();
if (res.ok) {
  alert("ログイン成功");
  sessionStorage.setItem("loggedInUser", JSON.stringify(data.user));

// ✅ role-based navigation
if (data.user.role === "admin") {
  navigate("/admin-dashboard");

} else if (data.user.role === "employee") {
  navigate("/employee-dashboard");
} else {
  navigate("/dashboard"); // fallback
}
      } else {
        alert(data.detail);
      }
    } catch (error) {
      alert("エラーが発生しました");
    }
  };

  const handleGoogleLogin = async (
    credentialResponse: CredentialResponse
  ) => {
    if (!credentialResponse.credential) {
      alert("Google認証情報を取得できませんでした");
      return;
    }

    try {
      const res = await fetch(
        "/users/google-login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            credential: credentialResponse.credential
          })
        }
      );

      const data = await res.json();

      if (!res.ok) {
        alert(data.detail || "Googleログインに失敗しました");
        return;
      }

      sessionStorage.setItem(
        "loggedInUser",
        JSON.stringify(data.user)
      );

      alert("Googleログイン成功");

      if (data.user.role === "admin") {
        navigate("/admin-dashboard");
      } else if (data.user.role === "employee") {
        navigate("/employee-dashboard");
      } else {
        alert("利用できないロールです");
      }
    } catch (error) {
      console.error("Google login error:", error);
      alert("Googleログイン中にエラーが発生しました");
    }
  };
  

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(90deg, #16295c 0%, #1f3f7a 55%, #239b95 100%)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px"
      }}
    >
      {/* LOGIN CARD */}
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          padding: "40px 30px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          textAlign: "center"
        }}
      >
        {/* ICON */}
        <div
          style={{
            width: "60px",
            height: "60px",
            background: "linear-gradient(135deg, #14b8a6, #22c55e)",
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px auto",
            fontSize: "28px",
            color: "white"
          }}
        >
          🎓
        </div>

        {/* TITLE */}
        <h2 style={{ marginBottom: "8px", color: "#1f2937" }}>
          LMSへようこそ
        </h2>

        <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "25px" }}>
          ログインしてダッシュボードにアクセス
        </p>

        {/* EMAIL */}
        <div style={{ textAlign: "left", marginBottom: "15px" }}>
          <label style={{ fontSize: "14px", fontWeight: 500 }}>
            メールアドレス
          </label>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              width: "100%",
              marginTop: "5px",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #d1d5db",
              fontSize: "14px"
            }}
          />
        </div>

        {/* PASSWORD */}
        <div style={{ textAlign: "left", marginBottom: "20px" }}>
          <label style={{ fontSize: "14px", fontWeight: 500 }}>
            パスワード
          </label>
          <input
            type="password"
            placeholder="パスワードを入力"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              marginTop: "5px",
              padding: "12px",
              borderRadius: "10px",
              border: "1px solid #d1d5db",
              fontSize: "14px"
            }}
          />
        </div>

        {/* BUTTON */}
        <button
          onClick={handleLogin}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#14b8a6",
            color: "white",
            border: "none",
            borderRadius: "10px",
            fontSize: "16px",
            fontWeight: 600,
            cursor: "pointer"
          }}
        >
          ログイン
        </button>


                <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            margin: "22px 0"
          }}
        >
          <div
            style={{
              flex: 1,
              height: "1px",
              backgroundColor: "#e5e7eb"
            }}
          />

          <span
            style={{
              fontSize: "13px",
              color: "#6b7280"
            }}
          >
            または
          </span>

          <div
            style={{
              flex: 1,
              height: "1px",
              backgroundColor: "#e5e7eb"
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%"
          }}
        >
          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={() => {
              alert("Googleログインに失敗しました");
            }}
            useOneTap={false}
            text="signin_with"
            shape="rectangular"
            theme="outline"
            size="large"
          />
        </div>

        {/* CONTACT */}
        <p
          style={{
            marginTop: "20px",
            fontSize: "13px",
            color: "#6b7280"
          }}
        >
          アカウントがない場合は管理者へお問い合わせください
        </p>
      </div>

      {/* BACK BUTTON */}
      <button
        onClick={() => navigate("/")}
        style={{
          marginTop: "20px",
          background: "transparent",
          border: "none",
          color: "white",
          cursor: "pointer",
          fontSize: "14px",
          textDecoration: "underline"
        }}
      >
        ← 戻る
      </button>

      {/* FOOTER */}
      <p
        style={{
          marginTop: "30px",
          fontSize: "12px",
          color: "rgba(255,255,255,0.7)"
        }}
      >
        © 2026 LMS. All rights reserved.
      </p>
    </div>
  );
}

export default LoginPage;